import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7sm36dmfku: FaireBrandEntity = {
  token: "b_7sm36dmfku",
  type: "brand",
  name: "Crispy Ho",
  avatarUrl:
    "https://cdn.faire.com/fastly/72591a6e3d38b62f7d6b27441fbf79e41f8b671d432280e7cdf207c9e363b8a5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/868b0da24a01ceac00225fa4495e8552ef190d563dcee7ebdb81350c7b1de645.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/72591a6e3d38b62f7d6b27441fbf79e41f8b671d432280e7cdf207c9e363b8a5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/868b0da24a01ceac00225fa4495e8552ef190d563dcee7ebdb81350c7b1de645.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 8,
  isInsider: true,
  description:
    "I grew up cooking with my grandmother, a hardworking Vietnamese woman who made everything from scratch. You could taste the love in her food, and it brought our friends and family together for some of my happiest memories growing up.\n\nMy goal in creating Crispy Ho was to carry on the traditions and values my grandmother passed on to me. I wanted to make a clean, versatile, delicious chili crunch that anyone could use to immediately elevate their food (and hopefully make some happy memories of their own). I am so excited and proud to share this with you.\n\n-Nancy Ho, Founder",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:25.035Z",
    importedBy: "entity-db-cli",
  },
};
